var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStopwatch = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.99 6.99a8.5 8.5 0 0 1 12.02 0l.302.317a8.5 8.5 0 1 1-12.323-.318m11.034.44a7.501 7.501 0 1 0 .546.547l-.266-.28z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.1 12.005c.472.046.847.42.895.89l.005.103v.003a.999.999 0 1 1-2 0c0-.553.448-.999.998-1.001z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5 13V9a.5.5 0 1 1 1 0v4a.5.5 0 0 1-1 0M14 1.5a.5.5 0 0 1 0 1h-4a.5.5 0 1 1 0-1zm4.646 2.146a.5.5 0 0 1 .707 0l2 2 .065.079a.5.5 0 0 1-.772.629L20 5.707l-1.99 1.99a.5.5 0 1 1-.706-.708L19.293 5l-.647-.646a.5.5 0 0 1 0-.708"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStopwatch);
export default ForwardRef;